import { PageOwnerType } from "../enums/PageOwnerType";
import { Company } from "../enums/Company";
import { PlatformStatus } from "../enums/PlatformStatus";

export class ManagedPage {
    PageID: string = ``;
    PageName: string = '';
    DDID: string = '';
    DomainName: string = '';
    About: string = '';
    Phone: string = '';
    Website: string = '';
    HasWebhook: boolean = false;
    Status: PlatformStatus = PlatformStatus.Inactive;
    OwnerType: PageOwnerType = PageOwnerType.Witco;
    Company: Company = Company.CINC;
}